import { BTButtonDeprecated } from "commonComponents/btWrappers/BTButtonDeprecated/BTButtonDeprecated";

interface ICheckedActionsProps {
    onUnselectAll: () => void;
    count?: number;
    children?: React.ReactNode;
}

export const CheckedActions: React.FunctionComponent<ICheckedActionsProps> = (props) => {
    return (
        <div className="flex flex-shrink-0">
            <div className="SelectedItemsBanner" data-testid="SelectedItemsBanner">
                {props.count && `${props.count} selected`}
                <BTButtonDeprecated
                    type="link"
                    data-testid="cancel-checked"
                    onClick={props.onUnselectAll}
                >
                    Cancel
                </BTButtonDeprecated>
            </div>
            {props.children}
        </div>
    );
};
